module.exports = __webpack_public_path__ + "static/media/dice-two.2c6f80f3.svg";